import React, { useEffect, FunctionComponent, useState } from 'react';
import { Redirect, RouteComponentProps, useParams } from 'react-router-dom';
import { rejectRequest } from '../../network/institution';
import { ROUTES } from '../../routing/routes';
import { RootState } from '../../redux';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { hydrate } from '../../redux/reducers/session';
import { types_users } from '../../types/users';
import { getRole, getToken } from '../../localStorage';

type PropsLocation = {
  location?: RouteComponentProps<{ path: string }, {}, { state: string }>;
};

interface ParamTypes {
  id: any;
}

const RedirectingPageReject: FunctionComponent<PropsLocation> = props => {
  const params = useParams<ParamTypes>();
  const dispatch = useAppDispatch();
  const id = useAppSelector((state: RootState) => state.session.id);
  const role = getRole();
  const [confirmed, setConfirmed] = useState(false);

  const rejectInvitation = (id: any) => {
    id && rejectRequest(id).then(({}) => setConfirmed(true));
  };

  useEffect(() => {
    rejectInvitation(params.id);
  });

  return (
    <React.Fragment>
      {confirmed && <Redirect to={ROUTES.INSTITUTION} />}
    </React.Fragment>
  );
};

export default RedirectingPageReject;
